/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useMemo,
} from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Tooltip,
  Grid,
  Typography,
  Select as AntSelect,
  Divider,
} from 'antd';
import { PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import API from 'utils/api';
import makeMessager from 'utils/complexFormsMessages';
import { onError } from 'utils/handlers';
import Select from 'components/Select';
import { getCodigosPostales } from 'api/catalogos';
import Mapa from 'components/Mapa';
import { toInteger } from 'utils/normalizers';
import { getModelPermission } from 'utils/permission';
import DireccionVerificada, { modelCrud as modelVerificacion } from 'components/Direccion/Verificada';
import { getColindancias } from 'api/catastro/colindancias';
import { getTiposDeVialidades } from 'api/usuarios';
import formatValues from 'utils/formatValues';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import { patchPadronesMap as _patchPadronesMap, urlsPadronesMap as urls } from 'api/recaudacion/utils';
import addressToString from 'utils/address';
import { dateKeysPredio } from 'api/catastro/predio';
import {
  getOrientacionesDePredios,
  getSectoresCatastralesDePredios,
  getRegionesCatastralesDePredios,
  getParcelasDePredios,
  getSeccionesDePredios,
  getEdificiosDePredios,
  getUnidadesDePredios,
  getManzanasDePredios,
  getTiposDeCondominiosDePredios,
} from 'api/catastro';
import removeIndexes from 'views/Tramites/GPM/removeIndexes';
import BusquedaCodigoPostal from './BusquedaCodigoPostal';
import getAllPages from '../../utils/getAllPages';

export const fieldsDetalle = [
  ['sector_catastral', 'Sector Catastral'],
  ['region_catastral', 'Región Catastral'],
  ['parcela', 'Parcela'],
  ['seccion', 'Sección'],
  ['lote_iprovinay', 'Lote'],
  ['edificio', 'Edificio'],
  ['unidad', 'Unidad'],
  ['manzana', 'Manzana'],
  ['tipo_de_condominio', 'Condominio'],
  ['coordenada_utm_x'],
  ['coordenada_utm_y'],
];

export const permissionConfig = {
  title: 'Dirección',
  model: 'direccion',
  catalogs: [
    'tipodevialidad',
    'codigopostal',
    'catalogodepais',
    'colindanciadepredios',
    'estado',
    'municipio',
    modelVerificacion,
  ],
};

const patchPadronesMap = {
  [urls[padronesEnum.CIUDADANO]]: _patchPadronesMap[padronesEnum.CIUDADANO],
  [urls[padronesEnum.EMPRESA]]: _patchPadronesMap[padronesEnum.EMPRESA],
  [urls[padronesEnum.PREDIO]]: _patchPadronesMap[padronesEnum.PREDIO],
  [urls[padronesEnum.VEHICULO]]: _patchPadronesMap[padronesEnum.VEHICULO],
  [urls[padronesEnum.HOSPEDAJE]]: _patchPadronesMap[padronesEnum.HOSPEDAJE],
  [urls[padronesEnum.ARRENDAMIENTO]]: _patchPadronesMap[padronesEnum.ARRENDAMIENTO],
  [urls[padronesEnum.NOMINA]]: _patchPadronesMap[padronesEnum.NOMINA],
  [urls[padronesEnum.ALCOHOL]]: _patchPadronesMap[padronesEnum.ALCOHOL],
  [urls[padronesEnum.CEDULAR]]: _patchPadronesMap[padronesEnum.CEDULAR],
  [urls[padronesEnum.JUEGO_DE_AZAR]]: _patchPadronesMap[padronesEnum.JUEGO_DE_AZAR],
  [urls[padronesEnum.NOTARIO]]: _patchPadronesMap[padronesEnum.NOTARIO],
  [urls[padronesEnum.CASA_DE_EMPENIO]]: _patchPadronesMap[padronesEnum.CASA_DE_EMPENIO],
  [urls[padronesEnum.AGENCIA]]: _patchPadronesMap[padronesEnum.AGENCIA],
  [urls[padronesEnum.CONTRIBUYENTE]]: _patchPadronesMap[padronesEnum.CONTRIBUYENTE],
  [urls[padronesEnum.MOTOCICLETA]]: _patchPadronesMap[padronesEnum.MOTOCICLETA],
  [urls[padronesEnum.REMOLQUE]]: _patchPadronesMap[padronesEnum.REMOLQUE],
  [urls[padronesEnum.POLICIA_ESPECIAL]]: _patchPadronesMap[padronesEnum.POLICIA_ESPECIAL],
  [urls[padronesEnum.INFRACCIONES]]: _patchPadronesMap[padronesEnum.INFRACCIONES],
  [urls[padronesEnum.COMERCIO_INFORMAL]]: _patchPadronesMap[padronesEnum.COMERCIO_INFORMAL],
  [urls[padronesEnum.MERCADO]]: _patchPadronesMap[padronesEnum.MERCADO],
  // eslint-disable-next-line max-len
  [urls[padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO]]: _patchPadronesMap[padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO],
  [urls[padronesEnum.ZONA_EXCLUSIVA]]: _patchPadronesMap[padronesEnum.ZONA_EXCLUSIVA],
  [urls[padronesEnum.EXPEDIENTE_DE_ANUNCIO]]: _patchPadronesMap[padronesEnum.EXPEDIENTE_DE_ANUNCIO],
  [urls[padronesEnum.MULTAS]]: _patchPadronesMap[padronesEnum.MULTAS],
  [urls[padronesEnum.VENDEDOR_DE_ALCOHOLES]]: _patchPadronesMap[padronesEnum.VENDEDOR_DE_ALCOHOLES],
  [urls[padronesEnum.RETENEDOR_DE_CEDULA]]: _patchPadronesMap[padronesEnum.RETENEDOR_DE_CEDULA],
  [urls[padronesEnum.RETENEDOR_DE_NOMINA]]: _patchPadronesMap[padronesEnum.RETENEDOR_DE_NOMINA],
  [urls[padronesEnum.SERVICIO_PUBLICO]]: _patchPadronesMap[padronesEnum.SERVICIO_PUBLICO],
  [urls[padronesEnum.ESTACIONAMIENTO]]: _patchPadronesMap[padronesEnum.ESTACIONAMIENTO],
  [urls[padronesEnum.LOTES_DE_PANTEON]]: _patchPadronesMap[padronesEnum.LOTES_DE_PANTEON],
};

// const colindanciasDefault = (new Array(4)).fill({}).map((e, i) => ({ orientacion: i + 1 }));
const colindanciasDefault = [{}];

const formatAddressValues = (values) => {
  const keys = Object.keys(values);
  const clone = {};
  keys.forEach((prop) => {
    const value = values[prop];
    if (value && value !== 'N/A') {
      clone[prop] = value;
    }
  });
  return clone;
};

const initialValues = {
  estado_texto: 'Jalisco',
  municipio_texto: 'Tlajomulco de Zúñiga',
};

const baseGetDireccion = async ({
  setLoading,
  formInstance,
  useParentID,
  parentID,
  currentURI,
  addressPropName,
  getCodigoPostal,
  valuesCallback,
  showColindancias,
  noAfectarPadron = false,
  showDetalle,
  mutable,
  isContribuyente,
}) => {
  formInstance.resetFields();
  let formattedValues = { colindancias: [], ...(isContribuyente ? initialValues : {}) };
  try {
    setLoading(true);
    if (!useParentID || parentID) {
      const { data } = await API.get(`${currentURI}${useParentID ? `${parentID}/` : ''}`);
      const json_predio = data.json_predio ? JSON.parse(data.json_predio) : removeIndexes(data);
      delete data.json_predio;
      delete json_predio.json_predio;
      const direccion = noAfectarPadron ? json_predio[addressPropName] : data[addressPropName];
      if (noAfectarPadron) {
        formattedValues.json_predio = json_predio;
      }
      if (showDetalle) {
        fieldsDetalle.forEach(([name]) => {
          if (direccion) {
            direccion[name] = (noAfectarPadron ? json_predio : data)[name];
          }
          formattedValues[name] = (noAfectarPadron ? json_predio : data)[name];
        });
      }
      if (direccion) {
        const codigo_postal = direccion.codigo_postal?.id || direccion.codigo_postal;
        const codigoPostal = codigo_postal ? await getCodigoPostal(codigo_postal) : undefined;
        formattedValues = formatAddressValues({
          ...formattedValues,
          ...direccion,
          codigo_postal: codigoPostal?.id,
          pais: codigoPostal?.municipio.pais,
          estado: codigoPostal?.municipio.estado.nombre_de_AGEE,
          estado_texto: direccion.estado_texto || codigoPostal?.municipio.estado.nombre_de_AGEE,
          municipio: codigoPostal?.municipio.nom_mun,
          municipio_texto: direccion.municipio_texto || codigoPostal?.municipio.nom_mun,
          cp_texto: direccion.cp_texto || codigoPostal?.d_codigo,
          d_codigo: isContribuyente ? direccion.cp_texto : codigoPostal?.d_codigo,
          colonia_texto: direccion.colonia_texto || codigoPostal?.d_asenta,
        });
      }
      if (showColindancias) {
        const colindancias = await getColindancias({ predio: data.id });
        formattedValues.colindancias = mutable && !colindancias.length
          ? colindanciasDefault : colindancias;
      }
      formInstance.setFieldsValue(formattedValues);
      if (valuesCallback) valuesCallback(direccion ? formattedValues : null, direccion);
      setLoading(false);
      if (direccion) return formattedValues;
    }
  } catch (err) {
    onError(err, setLoading);
  }
  setLoading(false);
  formInstance.setFieldsValue(formattedValues);
  return null;
};

const FormItemsDireccion = forwardRef((props, ref) => {
  const {
    setVisibleNoSeCodigo,
    collpasedSidebar,
    tiposVialidades,
    orientacionesDePredios: _orientacionesDePredios,
    allowVerify,
    permission,
    setLoading,
    visibleNoSeCodigo,
    addressPropName,
    triggerClone,
    mutable: _mutable,
    entidad,
    allowMap,
    allowCloneFrom,
    getDireccion,
    parentID,
    loading,
    showColindancias,
    showDetalle,
    isPredio,
    isContribuyente,
    catalogosDetalle,
  } = props;
  const paises = useSelector((s) => s.catalogs.paises);
  const screens = Grid.useBreakpoint();
  const formInstance = Form.useFormInstance();
  const direccionId = Form.useWatch('id', formInstance);
  const colonia_texto = Form.useWatch('colonia_texto', formInstance);
  const codigo_postal = Form.useWatch('codigo_postal', formInstance);
  const colindancias = Form.useWatch('colindancias', formInstance);
  const entre_calle = Form.useWatch('entre_calle', formInstance);
  const tipo_de_vialidad_entre = Form.useWatch('tipo_de_vialidad_entre', formInstance);
  const y_calle = Form.useWatch('y_calle', formInstance);
  const tipo_de_vialidad_y_calle = Form.useWatch('tipo_de_vialidad_y_calle', formInstance);
  const mutable = _mutable && ((!direccionId && permission?.add)
    || (direccionId && permission?.change));
  const [colonias, setColonias] = useState([]);

  const fillValuesFromColonies = async (_colonias) => {
    try {
      setLoading(true);
      const _pais = formInstance.getFieldValue('pais');
      const fromCountry = _colonias.filter((e) => e.municipio.pais === _pais);
      if (fromCountry.length) {
        const [codigoPostal] = fromCountry;
        if (fromCountry.length === 1) {
          formInstance.setFieldsValue({
            codigo_postal: codigoPostal.id,
            pais: codigoPostal.municipio.pais,
            estado_texto: codigoPostal.municipio.estado.nombre_de_AGEE,
            estado: codigoPostal.municipio.estado.nombre_de_AGEE,
            municipio_texto: codigoPostal.municipio.nom_mun,
            municipio: codigoPostal.municipio.nom_mun,
            colonia_texto: codigoPostal.d_asenta,
            d_codigo: codigoPostal.d_codigo,
          });
        } else {
          formInstance.setFieldsValue({
            codigo_postal: null,
            pais: codigoPostal.municipio.pais,
            estado_texto: codigoPostal.municipio.estado.nombre_de_AGEE,
            estado: codigoPostal.municipio.estado.nombre_de_AGEE,
            municipio_texto: codigoPostal.municipio.nom_mun,
            municipio: codigoPostal.municipio.nom_mun,
            colonia_texto: null,
            d_codigo: codigoPostal.d_codigo,
          });
        }
      } else {
        message.info('No se encontro información relacionada al código postal brindado');
        formInstance.setFieldsValue({
          codigo_postal: null,
          ...(isContribuyente ? initialValues : {}),
        });
      }
      setLoading(false);
      ref.current?.focus();
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onFinishSearch = async (values) => {
    setLoading(true);
    const codigoPostal = Array.isArray(values) ? values[0] : values;
    if (codigoPostal) {
      formInstance.setFieldsValue({
        pais: codigoPostal.municipio.pais,
        estado_texto: codigoPostal.municipio.estado.nombre_de_AGEE,
        estado: codigoPostal.municipio.estado.nombre_de_AGEE,
        municipio_texto: codigoPostal.municipio.nom_mun,
        municipio: codigoPostal.municipio.nom_mun,
        codigo_postal: codigoPostal.id,
        cp_texto: codigoPostal.d_codigo,
        colonia_texto: codigoPostal.d_asenta,
        d_codigo: codigoPostal.d_codigo,
      });
      const _colonias = await getAllPages(getCodigosPostales, { d_codigo: codigoPostal.d_codigo });
      setColonias(_colonias);
      setVisibleNoSeCodigo(false);
    } else {
      message.warn('Seleccione un elemento');
    }
    setLoading(false);
  };

  const onSearchCodigoPostal = async (d_codigo, fill = false) => {
    if (d_codigo?.toString()?.length === 5) {
      setLoading(true);
      const _colonias = await getAllPages(getCodigosPostales, { d_codigo });
      setColonias(_colonias);
      if (fill) await fillValuesFromColonies(_colonias);
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetch = async () => {
      if (!direccionId) {
        setLoading(true);
        const direccion = await getDireccion();
        if (direccion?.codigo_postal) {
          const _colonias = await getAllPages(getCodigosPostales, { id: direccion.codigo_postal });
          setColonias(_colonias);
        }
        setLoading(false);
      }
    };
    fetch();
    formInstance.setFieldsValue({ misma_direccion_fiscal: false });
    if (!direccionId) {
      setTimeout(() => formInstance.setFieldsValue({
        pais: entidad.pais,
        tipo_de_vialidad: 5,
        misma_direccion_fiscal: false,
        ...(isContribuyente ? initialValues : {}),
      }));
    }
  }, [direccionId, parentID]);

  const onClone = () => {
    const d_codigo = formInstance.getFieldValue('d_codigo');
    if (d_codigo) onSearchCodigoPostal(d_codigo);
  };

  useEffect(() => { if (triggerClone) onClone(); }, [triggerClone]);

  const onChange = async (same) => {
    if (same) {
      onClone();
      setLoading(true);
      const direccion = await getDireccion(allowCloneFrom);
      if (direccion) {
        await onSearchCodigoPostal(direccion.d_codigo);
        formInstance.setFieldsValue({ misma_direccion_fiscal: true });
      } else {
        message.info('No se encontró dirección para copiar');
        formInstance.setFieldsValue({ misma_direccion_fiscal: false });
      }
    } else {
      formInstance.resetFields();
    }
  };

  const orientacionesDePredios = _orientacionesDePredios.map((e) => ({
    ...e,
    disabled: colindancias?.some((c) => c.orientacion === e.id),
  }));

  const rules = {
    required: [{ required: true }],
    entre_calle: [{ required: !!tipo_de_vialidad_entre }],
    tipo_de_vialidad_entre: [{ required: !!entre_calle }],
    y_calle: [{ required: !!tipo_de_vialidad_y_calle }],
    tipo_de_vialidad_y_calle: [{ required: !!y_calle }],
    codigo_postal: isContribuyente ? [
      {
        validator: async (_, val) => {
          if (val || colonia_texto) return;
          throw new Error('Seleccione o ingrese colonia');
        },
      },
    ] : [{ required: true }],
  };

  const onCopy = () => {
    const formValues = formInstance.getFieldsValue();
    const values = { ...formValues };
    values.codigo_postal = colonias.find((c) => c.id === formValues.codigo_postal);
    if (values.codigo_postal) {
      values.codigo_postal.municipio.estado.pais = paises.find((p) => p.id === values.pais);
    }
    formInstance.setFieldValue('direccion_de_titulo', addressToString(values));
  };

  return (
    <>
      <Col span={24}>
        {!!allowCloneFrom && mutable && (
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="misma_direccion_fiscal"
                label="¿Copiar dirección existente?"
              >
                <Select trueFalse onChange={onChange} disabled={!mutable} />
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row gutter={10} align="middle">
          <Col xs={24} sm={24} md={6}>
            <Form.Item
              label={(
                <>
                  <span style={{ marginRight: 5 }}>
                    Código Postal
                  </span>
                  {mutable && !isContribuyente && (
                    <Tooltip
                      title="Ingresar este campo llenara automáticamente estado, municipio y las colonias disponibles"
                    >
                      <QuestionCircleOutlined className="primary-on-hover" />
                    </Tooltip>
                  )}
                </>
              )}
              name="d_codigo"
              normalize={toInteger}
            >
              <Input.Search
                onPressEnter={(e) => {
                  e.preventDefault();
                  if (loading) return;
                  onSearchCodigoPostal(formInstance.getFieldValue('d_codigo'), true);
                }}
                maxLength={6}
                onSearch={(d_codigo) => onSearchCodigoPostal(d_codigo, true)}
                disabled={!mutable}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={6}>
            <Form.Item>
              <Button
                type="link"
                onClick={() => setVisibleNoSeCodigo(true)}
                className="primary-on-hover"
                style={{ marginTop: 12 }}
                disabled={!mutable}
              >
                No sé mi código
              </Button>
            </Form.Item>
          </Col>
          {/* <Col xs={24} sm={24} md={6}>
            <Form.Item>
              <Button
                onClick={() => formInstance.resetFields(['codigo_postal'])}
                style={{ marginTop: 12 }}
                disabled={!mutable}
              >
                Limpiar
              </Button>
            </Form.Item>
          </Col> */}
          <Col span={24} />
          <Col xs={24} sm={24} md={6}>
            <Form.Item
              name="pais"
              label="País"
              rules={rules.required}
            >
              <Select
                dataSource={paises}
                labelProp="descripcion"
                disabled={!mutable}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={6}>
            <Form.Item
              name={isContribuyente ? 'estado_texto' : 'estado'}
              label="Estado"
              rules={rules.required}
            >
              <Input disabled={!isContribuyente || !mutable} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={6}>
            <Form.Item
              name={isContribuyente ? 'municipio_texto' : 'municipio'}
              label="Municipio"
              rules={rules.required}
            >
              <Input disabled={!isContribuyente || !mutable} />
            </Form.Item>
          </Col>
          {isContribuyente && (
            <Form.Item name="colonia_texto" hidden>
              <Input />
            </Form.Item>
          )}
          <Col xs={24} sm={24} md={6}>
            <Form.Item noStyle>
              <Form.Item
                label="Colonia"
                name="codigo_postal"
                rules={rules.codigo_postal}
                requiredMark
              >
                <AntSelect
                  allowClear={mutable}
                  options={colonias.map((c) => ({
                    label: isContribuyente ? (
                      <>
                        <Typography.Text>
                          {c.id === codigo_postal ? colonia_texto || c.d_asenta : c.d_asenta}
                        </Typography.Text>
                        {c.id === codigo_postal && c.d_asenta !== colonia_texto && (
                          <>
                            <br />
                            <Typography.Text delete>{c.d_asenta}</Typography.Text>
                          </>
                        )}
                      </>
                    ) : c.d_asenta,
                    value: c.id,
                  }))}
                  dropdownRender={isContribuyente ? (menu) => (
                    <>
                      {menu}
                      <Divider style={{ margin: '8px 0' }} />
                      <Input
                        prefix={<b>Colonia texto: </b>}
                        value={colonia_texto || ''}
                        onChange={(e) => formInstance.setFieldValue('colonia_texto', e.target.value)}
                      />
                    </>
                  ) : undefined}
                  disabled={!mutable}
                  placeholder={!codigo_postal && colonia_texto ? colonia_texto : undefined}
                />
              </Form.Item>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={collpasedSidebar ? 8 : 12}>
            <Form.Item noStyle>
              <Input.Group style={{ display: 'flex' }} compact>
                <Form.Item
                  name="tipo_de_vialidad"
                  rules={rules.required}
                  label="Tipo"
                >
                  <Select
                    style={{ width: 150 }}
                    dataSource={tiposVialidades}
                    disabled={!mutable}
                  />
                </Form.Item>
                <Form.Item
                  name="calle_principal"
                  label="Vialidad Principal"
                  rules={rules.required}
                  style={{ width: 'calc(100% - 150px)' }}
                >
                  <Input maxLength={170} disabled={!mutable} allowClear />
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={6}>
            <Form.Item
              name="numero_exterior"
              label="Número Exterior"
              rules={rules.required}
            >
              <Input maxLength={20} ref={ref} disabled={!mutable} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={6}>
            <Form.Item
              name="numero_interior"
              label="Número Interior"
            >
              <Input maxLength={20} disabled={!mutable} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={collpasedSidebar ? 8 : 12}>
            <Form.Item noStyle>
              <Input.Group style={{ display: 'flex' }} compact>
                <Form.Item
                  name="tipo_de_vialidad_entre"
                  label="Tipo"
                  rules={rules.tipo_de_vialidad_entre}
                >
                  <Select
                    style={{ width: 150 }}
                    dataSource={tiposVialidades}
                    disabled={!mutable}
                    onChange={() => formInstance.validateFields(['entre_calle'])}
                  />
                </Form.Item>
                <Form.Item
                  name="entre_calle"
                  rules={rules.entre_calle}
                  label="Entre Vialidad"
                  style={{ width: 'calc(100% - 150px)' }}
                >
                  <Input
                    onChange={() => formInstance.validateFields(['tipo_de_vialidad_entre'])}
                    maxLength={170}
                    disabled={!mutable}
                    allowClear
                  />
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={collpasedSidebar ? 8 : 12}>
            <Form.Item noStyle>
              <Input.Group style={{ display: 'flex' }} compact>
                <Form.Item
                  name="tipo_de_vialidad_y_calle"
                  label="Tipo"
                  rules={rules.tipo_de_vialidad_y_calle}
                >
                  <Select
                    style={{ width: 150 }}
                    dataSource={tiposVialidades}
                    disabled={!mutable}
                    onChange={() => formInstance.validateFields(['y_calle'])}
                  />
                </Form.Item>
                <Form.Item
                  name="y_calle"
                  rules={rules.y_calle}
                  label="Y Vialidad"
                  style={{ width: 'calc(100% - 150px)' }}
                >
                  <Input
                    onChange={() => formInstance.validateFields(['tipo_de_vialidad_y_calle'])}
                    maxLength={170}
                    disabled={!mutable}
                    allowClear
                  />
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </Col>
          {showColindancias && (
            <>
              <Col span={24} style={{ marginTop: 20 }}>
                <Typography.Title level={3} style={{ margin: 0 }}>
                  Colindancias
                </Typography.Title>
              </Col>
              <Form.List name="colindancias">
                {(fields, { add }) => (
                  <>
                    {fields.map(({ key, name, ...restField }, idx) => {
                      const prevItem = colindancias?.[idx - 1];
                      const item = colindancias?.[idx];
                      return (
                        <Col
                          xs={24}
                          sm={24}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={6}
                          key={key}
                        >
                          <Row style={{ width: '100%' }}>
                            <Form.Item
                              // eslint-disable-next-line react/jsx-props-no-spreading
                              {...restField}
                              name={[name, 'id']}
                              hidden
                            >
                              <Input />
                            </Form.Item>
                            <Col style={{ width: screens.md ? 135 : '100%' }}>
                              <Form.Item
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...restField}
                                label="Orientación"
                                name={[name, 'orientacion']}
                                rules={[{
                                  required: !!item?.orientacion || !!item?.colindancia
                                    || !!item?.metros,
                                }]}
                              >
                                <Select
                                  dataSource={orientacionesDePredios}
                                  disabled={!mutable || (prevItem && !prevItem?.colindancia)}
                                  allowClear
                                  style={{ width: screens.md ? 135 : '100%' }}
                                />
                              </Form.Item>
                            </Col>
                            <Col style={{ width: screens.md ? 80 : '100%' }}>
                              <Form.Item
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...restField}
                                label="Metros"
                                name={[name, 'distancia']}
                                rules={[{ required: !!item?.colindancia }]}
                              >
                                <Input
                                  disabled={!mutable || !item?.orientacion
                                    || (prevItem && !prevItem?.colindancia)}
                                  allowClear
                                  style={{ width: screens.md ? 80 : '100%' }}
                                />
                              </Form.Item>
                            </Col>
                            <Col style={{ width: screens.md ? 'calc(100% - 215px)' : '100%' }}>
                              <Form.Item
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...restField}
                                label="Con Lote/Calle"
                                name={[name, 'colindancia']}
                                rules={[{ required: !!item?.distancia }]}
                              >
                                <Input
                                  disabled={!mutable || !item?.distancia
                                    || (prevItem && !prevItem?.colindancia)}
                                  allowClear
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                      );
                    })}
                    {mutable && (
                      <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={6}>
                        <Form.Item>
                          <Button
                            onClick={() => add({})}
                            icon={<PlusOutlined />}
                            style={{ marginTop: 22 }}
                            disabled={!(colindancias?.[colindancias.length - 1]?.distancia
                              && colindancias?.[colindancias.length - 1]?.colindancia
                              && colindancias?.[colindancias.length - 1]?.orientacion)}
                          >
                            Añadir colindancia
                          </Button>
                        </Form.Item>
                      </Col>
                    )}
                  </>
                )}
              </Form.List>
              <Col span={24} />
            </>
          )}
          <Col span={24} style={{ marginBottom: 24, marginTop: 24 }}>
            <Form.Item
              name="descripcion_de_la_ubicacion"
              label="Descripción de la Ubicación"
            >
              <Input.TextArea
                autoSize={{ minRows: 2, maxRows: 3 }}
                maxLength={250}
                disabled={!mutable}
                allowClear
              />
            </Form.Item>
          </Col>
          {isPredio && (
            <Col span={24} style={{ marginBottom: 24, marginTop: 24 }}>
              <Form.Item
                name="direccion_de_titulo"
                label="Dirección en título"
              >
                <Input
                  disabled={!mutable}
                  addonAfter={mutable && <Button onClick={onCopy}>Copiar Dirección</Button>}
                  allowClear
                />
              </Form.Item>
            </Col>
          )}
          {!isContribuyente && (
            <>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  name="cp_texto"
                  label="Código Postal (Texto)"
                  normalize={toInteger}
                >
                  <Input
                    disabled={!mutable}
                    maxLength={5}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  name="colonia_texto"
                  label="Colonia (Texto)"
                >
                  <Input
                    disabled={!mutable}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  name="municipio_texto"
                  label="Municipio (Texto)"
                >
                  <Input
                    disabled={!mutable}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  name="estado_texto"
                  label="Estado (Texto)"
                >
                  <Input
                    disabled={!mutable}
                    allowClear
                  />
                </Form.Item>
              </Col>
            </>
          )}
          {showDetalle && fieldsDetalle.map(([name, label, normalize], idx) => {
            if (!label) return null;

            const cat = catalogosDetalle[idx];
            return (
              <React.Fragment key={name}>
                <Col xs={24} sm={24} md={6}>
                  <Form.Item
                    name={name}
                    label={label}
                    normalize={normalize}
                  >
                    {cat
                      ? <Select dataSource={cat} disabled={!mutable} />
                      : <Input disabled={!mutable} allowClear />}
                  </Form.Item>
                </Col>
              </React.Fragment>
            );
          })}
          <Form.Item hidden><Button htmlType="submit" /></Form.Item>
        </Row>
        <Form.Item name="id" hidden><Input /></Form.Item>
        {allowMap && (
          <Col span={24} style={{ margin: '30px 0 ' }} key={direccionId}>
            <Mapa
              interactive={mutable}
              form={formInstance}
              disabled={!mutable}
            />
          </Col>
        )}
        {allowVerify && direccionId && permission.catalogs[modelVerificacion].view && (
          <Col span={24}>
            <DireccionVerificada direccionId={direccionId} mutable={!mutable} />
          </Col>
        )}
      </Col>
      <Form.Item name="json_predio" hidden><Input /></Form.Item>
      <BusquedaCodigoPostal
        setLoading={setLoading}
        callback={onFinishSearch}
        setVisible={setVisibleNoSeCodigo}
        visible={visibleNoSeCodigo}
        addressPropName={addressPropName}
        modal
      />
    </>
  );
});

const Direccion = ({
  useParentID,
  parentID,
  setLoading: _setLoading,
  callback,
  currentURI: _currentURI,
  setFormAddress,
  addressPropName,
  setCurrentTabKey,
  mutable: _mutable,
  allowMap,
  allowVerify,
  triggerClone,
  valuesCallback,
  allowCloneFrom,
  loading: _loading,
  noAfectarPadron,
}) => {
  const permission = useMemo(
    () => getModelPermission(permissionConfig.model, permissionConfig.catalogs),
    [],
  );
  const currentURI = _currentURI.at(-1) !== '/' ? `${_currentURI}/` : _currentURI;
  const [useForm] = Form.useForm();
  const useFormInstance = Form.useFormInstance();
  const formInstance = setFormAddress ? useForm : useFormInstance;
  const direccionId = Form.useWatch('id', formInstance);
  const tiposVialidades = useSelector(({ catalogs }) => catalogs.tiposVialidades);
  const orientacionesDePredios = useSelector(({ catalogs }) => catalogs.orientacionesDePredios);
  const collpasedSidebar = useSelector(({ app }) => app.collpasedSidebar);
  const entidad = useSelector(({ auth }) => auth.entidad);
  const [visibleNoSeCodigo, setVisibleNoSeCodigo] = useState(false);
  const [innerLoading, setInnerLoading] = useState(true);
  const loading = _setLoading ? _loading : innerLoading;
  const setLoading = _setLoading || setInnerLoading;
  const ref = useRef();
  const [sectoresCatastrales, setSectoresCatastrales] = useState([]);
  const [regionesCatastrales, setRegionesCatastrales] = useState([]);
  const [parcelas, setParcelas] = useState([]);
  const [secciones, setSecciones] = useState([]);
  const [edificios, setEdificios] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [manzanas, setManzanas] = useState([]);
  const [tiposDeCondominios, setTiposDeCondominios] = useState([]);

  const mutable = _mutable && ((!direccionId && permission?.add)
    || (direccionId && permission?.change));
  const isPredio = currentURI === urls[padronesEnum.PREDIO];
  const isContribuyente = currentURI === urls[padronesEnum.CONTRIBUYENTE];

  const showColindancias = process.env.REACT_APP_ENV_NAME === 'iprovinay' && isPredio;
  const showDetalle = isPredio && addressPropName === 'direccion';

  const getCodigoPostal = async (codigoPostal) => {
    if (!codigoPostal?.d_codigo) {
      const resCP = await API.get(`/catalogos/codigos-postales/${codigoPostal}/`);
      return resCP.data;
    }
    return codigoPostal;
  };

  const getDireccion = async (propName = addressPropName) => baseGetDireccion({
    setLoading,
    formInstance,
    useParentID,
    parentID,
    currentURI,
    addressPropName: propName,
    getCodigoPostal,
    valuesCallback,
    showColindancias,
    noAfectarPadron,
    showDetalle,
    mutable,
    isContribuyente,
  });

  const showMsg = makeMessager(setCurrentTabKey, getDireccion);

  const onFinish = async (_continue = true) => {
    try {
      setLoading(true);
      await formInstance.validateFields();
      const { json_predio: initJson, ..._values } = formInstance.getFieldsValue();
      let json_predio = { ...initJson };
      const valuesDireccion = formatValues(_values, { clean: false });
      let values = {};
      if (isPredio) {
        fieldsDetalle.forEach(([name]) => {
          values[name] = valuesDireccion[name];
          if (noAfectarPadron) {
            json_predio[name] = valuesDireccion[name];
          }
          delete valuesDireccion[name];
        });
      }
      values[addressPropName] = valuesDireccion;
      if (noAfectarPadron) {
        json_predio[addressPropName] = valuesDireccion;
        json_predio = JSON.stringify(formatValues(json_predio, { clean: false }, dateKeysPredio));
        values = { json_predio };
      }

      const patchPadron = patchPadronesMap[currentURI];
      const response = await (patchPadron ? patchPadron(parentID, values, 'UBICACION')
        : API.patch(`${currentURI}${useParentID ? parentID : ''}`, { ...values, accionInf: 'EDITAR_UBICACION' }));
      if (patchPadron ? !!response : response.status === 200) {
        message.info(`Dirección ${!direccionId ? 'agregada' : 'modificada'} correctamente`);
        setTimeout(() => {
          callback((patchPadron ? response : response.data)[addressPropName], _continue);
          if (_continue) getDireccion();
        });
      }
      setTimeout(() => setLoading(false));
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onFinishHandler = async (tabKey = null, _continue = true) => {
    try {
      if (tabKey) {
        showMsg(tabKey);
      } else {
        await onFinish(_continue);
      }
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    let isMounted = true;
    const fetch = async () => {
      setLoading(true);
      await getTiposDeVialidades();
      await getOrientacionesDePredios();
      const promises = [];
      if (isPredio) {
        promises.push(...[
          getSectoresCatastralesDePredios(),
          getRegionesCatastralesDePredios(),
          getParcelasDePredios(),
          getSeccionesDePredios(),
          getEdificiosDePredios(),
          getUnidadesDePredios(),
          getManzanasDePredios(),
          getTiposDeCondominiosDePredios(),
        ]);
      }
      const [
        _sectoresCatastrales,
        _regionesCatastrales,
        _parcelas,
        _secciones,
        _edificios,
        _unidades,
        _manzanas,
        _tiposDeCondominios,
      ] = await Promise.all(promises);
      if (isMounted) {
        setSectoresCatastrales(_sectoresCatastrales);
        setRegionesCatastrales(_regionesCatastrales);
        setParcelas(_parcelas);
        setSecciones(_secciones);
        setEdificios(_edificios);
        setUnidades(_unidades);
        setManzanas(_manzanas);
        setTiposDeCondominios(_tiposDeCondominios);
        setLoading(false);
      }
    };
    fetch();

    setTimeout(() => {
      if (setFormAddress) {
        formInstance.onFinishHandler = onFinishHandler;
        setFormAddress(formInstance);
      }
      ref.current?.focus();
    });

    return () => { isMounted = false; };
    // eslint-disable-next-line
  }, []);

  const catalogosDetalle = [
    sectoresCatastrales,
    regionesCatastrales,
    parcelas,
    secciones,
    null,
    edificios,
    unidades,
    manzanas,
    tiposDeCondominios,
  ];

  if (setFormAddress) {
    return (
      <Form
        name={addressPropName}
        form={formInstance}
        layout="vertical"
        onFinish={() => onFinish()}
        initialValues={isContribuyente ? initialValues : undefined}
      >
        <FormItemsDireccion
          mutable={mutable}
          setVisibleNoSeCodigo={setVisibleNoSeCodigo}
          collpasedSidebar={collpasedSidebar}
          tiposVialidades={tiposVialidades}
          orientacionesDePredios={orientacionesDePredios}
          allowVerify={allowVerify}
          ref={ref}
          permission={permission}
          setLoading={setLoading}
          visibleNoSeCodigo={visibleNoSeCodigo}
          addressPropName={addressPropName}
          triggerClone={triggerClone}
          entidad={entidad}
          allowMap={allowMap}
          allowCloneFrom={allowCloneFrom}
          getDireccion={getDireccion}
          parentID={parentID}
          loading={loading}
          showColindancias={showColindancias}
          showDetalle={showDetalle}
          noAfectarPadron={noAfectarPadron}
          isPredio={isPredio}
          isContribuyente={isContribuyente}
          catalogosDetalle={catalogosDetalle}
        />
      </Form>
    );
  }

  return (
    <FormItemsDireccion
      mutable={_mutable}
      setVisibleNoSeCodigo={setVisibleNoSeCodigo}
      collpasedSidebar={collpasedSidebar}
      tiposVialidades={tiposVialidades}
      orientacionesDePredios={orientacionesDePredios}
      allowVerify={allowVerify}
      ref={ref}
      permission={permission}
      setLoading={setLoading}
      visibleNoSeCodigo={visibleNoSeCodigo}
      addressPropName={addressPropName}
      triggerClone={triggerClone}
      entidad={entidad}
      allowMap={allowMap}
      allowCloneFrom={allowCloneFrom}
      getDireccion={getDireccion}
      parentID={parentID}
      loading={loading}
      showColindancias={showColindancias}
      showDetalle={showDetalle}
      noAfectarPadron={noAfectarPadron}
      isPredio={isPredio}
      isContribuyente={isContribuyente}
      catalogosDetalle={catalogosDetalle}
    />
  );
};

Direccion.propTypes = {
  parentID: PropTypes.number,
  callback: PropTypes.func,
  valuesCallback: PropTypes.func,
  currentURI: PropTypes.string.isRequired,
  addressPropName: PropTypes.string,
  setLoading: PropTypes.func,
  setFormAddress: PropTypes.func,
  setCurrentTabKey: PropTypes.func,
  mutable: PropTypes.bool,
  useParentID: PropTypes.bool,
  allowMap: PropTypes.bool,
  allowVerify: PropTypes.bool,
  triggerClone: PropTypes.bool,
  loading: PropTypes.bool,
  allowCloneFrom: PropTypes.string,
  noAfectarPadron: PropTypes.bool,
};

Direccion.defaultProps = {
  parentID: null,
  callback: () => { },
  addressPropName: 'direccion',
  mutable: true,
  useParentID: true,
  allowMap: true,
  allowVerify: false,
  triggerClone: false,
  valuesCallback: null,
  allowCloneFrom: null,
  setCurrentTabKey: null,
  setFormAddress: null,
  loading: false,
  setLoading: null,
  noAfectarPadron: false,
};

export default Direccion;
